<template>
  <svg
    :width="dimensions.width"
    :height="dimensions.height"
    :viewBox="`0 0 ${dimensions.width} ${dimensions.height}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 41629">
      <path id="Vector" d="M11.1158 38.33C12.548 40.8506 15.2214 42.3401 19.4034 42.3401H30.8609C37.5444 42.3401 40.4088 38.5209 40.4088 32.7922V13.6964C40.4088 7.9676 37.5444 4.14844 30.8609 4.14844H19.4034C12.7198 4.14844 9.85547 7.9676 9.85547 13.6964V15.6059" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <path id="Vector_2" d="M17.4922 21.334H23.2209" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <path id="Vector_3" d="M17.4922 13.6992H30.8593" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <path id="Vector_4" d="M33.0009 36.6129C33.9366 36.6129 34.6813 35.8682 34.6813 34.9325V30.655C34.6813 29.7193 33.9366 28.9746 33.0009 28.9746H28.7234C27.7877 28.9746 27.043 29.7193 27.043 30.655" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <path id="Vector_5" d="M28.9516 34.705C27.042 32.7954 25.7053 34.3613 23.6238 36.6719C22.669 37.7412 21.2941 37.6076 20.5303 36.3663L19.4609 34.6286" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <g id="Group">
        <path id="Vector_6" d="M9.47924 19.8641L16.2392 26.624C16.5065 26.8914 16.7548 27.3879 16.812 27.7507L17.1749 30.3286C17.3085 31.2643 16.6593 31.9136 15.7236 31.7799L13.1456 31.4171C12.7828 31.3598 12.2672 31.1115 12.019 30.8442L5.25906 24.0843C4.09422 22.9194 3.54044 21.5636 5.25906 19.845C6.97769 18.1264 8.33349 18.6802 9.49834 19.845L9.47924 19.8641Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"
        />
        <path id="Vector_7" d="M10.4463 20.8379C9.87343 22.9002 8.26938 24.5043 6.20703 25.0772" stroke="#435363" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      required: false,
      type: [Number, String],
      default: 47,
    },
    height: {
      required: false,
      type: [Number, String],
      default: 47,
    },
    useCustomDimensions: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultWidth: 47,
      defaultHeight: 47,
    };
  },
  computed: {
    dimensions() {
      return {
        width: this.useCustomDimensions ? this.width : this.defaultWidth,
        height: this.useCustomDimensions ? this.height : this.defaultHeight,
      };
    },
  },
};
</script>
